module.exports = __webpack_public_path__ + "static/media/satellite-dish.816b7020.svg";